<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
.text-size {
  font-size: 1.4rem;
  line-height: 2rem;
}

.main {
  text-align: center;
  padding: 0.4rem;
  /* padding-left: 0.4rem;
  padding-right: 0.4rem; */
}
.van-col {
  margin-bottom: 0.2rem;
}
.main .van-button {
  background-color: #5237eb;
  color: white;
  width: 100%;
  text-align: center;
}

.checked {
  background-color: v-bind(sGetConfig("color3"));
  color: #fff;
}
/* .van-button {
  background-color: #5237eb;
  color: white;
  width: 100%;
  text-align: center;
} */

.van-tabbar .van-button {
  background-color: #0c9630;
  color: white;
  width: 100%;
  padding: 0.2rem;
}

.el-button + .el-button {
  margin: 1px;
}

.el-button {
  font-size: 1.2rem;
  margin: 1px;
}
:root {
  /* --woosa: #C49B53;
  --woosa1: #F7CB5E; */
  --woosa: #f1a114;
  --woosa1: #c49b53;
  --woosa2: #f7cb5e;
}
.HideScrollbar::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE and Edge */

.HideScrollbar {
  -ms-overflow-style: none;
}

.shadow {
  box-shadow: 3px 1px 10px #8f8f8f;
  -webkit-box-shadow: 3px 1px 10px #8f8f8f;
  -moz-box-shadow: 3px 1px 10px #8f8f8f;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

#nav {
  padding: 30px;
  position: fixed;
  bottom: 0;
}

a {
  font-weight: bold;
  color: #2c3e50;
}

a.router-link-exact-active {
  color: #42b983;
}

/* .main {
  margin-left: 200px;
  padding: 1rem;
}
@media screen and (max-width: 767px) {
  .main {
    float: left;
    margin-left: 0;
    width: calc(100% - 2rem);
  }
} */
.C1 {
  color: v-bind(sGetConfig("color1"));
}
.C2 {
  color: v-bind(sGetConfig("color2"));
}
.C3 {
  color: v-bind(sGetConfig("color3"));
}
.C4 {
  color: #f56c6c;
}
</style>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
